import get from "lodash/get";
import { googlePX } from "./utils/helpers";

const GoogleSiteTag = {
  enable() {
    let script = document.createElement("script"); // NOSONAR
    script.type = "text/javascript";
    script.onload = function () {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-879298608";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  },
  init() {
    window.gtag("js", new Date());
    window.gtag("config", googlePX("init"));
  },
  consulta() {
    const pixelMethod = googlePX("consulta");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  oferta(context) {
    if (_BBVA_MOTOR === "ofertaPrestamosEmprendedores") {
      const pixelMethod = googlePX("oferta");
      if (pixelMethod)
        window.gtag("event", "conversion", {
          send_to: pixelMethod
        });
      return;
    }

    if (get(context, "state.esCliente", false)) {
      const pixelMethod = googlePX("cliente");
      if (pixelMethod)
        window.gtag("event", "conversion", {
          send_to: pixelMethod
        });
    } else {
      const pixelMethod = googlePX("noCliente");
      if (pixelMethod)
        window.gtag("event", "conversion", {
          send_to: pixelMethod
        });
    }
  },
  compruebaIdentidad() {
    const pixelMethod = googlePX("landingQR");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  paso1() {
    const pixelMethod = googlePX("paso1");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  paso2() {
    const pixelMethod = googlePX("paso2");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  paso3() {
    const pixelMethod = googlePX("paso3");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  continuaSucursal() {
    const pixelMethod = googlePX("continuaSucursal");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  paso4() {
    const pixelMethod = googlePX("paso4");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  loadingVeridas() {
    const pixelMethod = googlePX("loadingVeridas");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  biometriaOK() {
    const pixelMethod = googlePX("biometriaOK");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  solicita() {
    const pixelMethod = googlePX("solicita");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  entrega() {
    const pixelMethod = googlePX("entrega");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  resumen() {
    const pixelMethod = googlePX("resumen");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  contratos() {
    const pixelMethod = googlePX("contratos");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  gracias() {
    const pixelMethod = googlePX("gracias");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  usuario() {
    const pixelMethod = googlePX("usuario");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  celular() {
    const pixelMethod = googlePX("celular");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  final() {
    const pixelMethod = googlePX("final");
    if (pixelMethod)
      window.gtag("event", "conversion", {
        send_to: pixelMethod
      });
  },
  errorPage(context) {
    const pixelMethod = googlePX("mensaje");
    const errorCode = get(context, "mutation.payload", "");
    const erroresRechazo = [
      "RECHAZO_02",
      "RECHAZO_07",
      "RECHAZO_704",
      "calificacionInvalida",
      "rechazoAntecedentes",
      "residenteTemporal",
      "RECHAZO_703",
      "RECHAZO_04",
      "RECHAZO_05",
      "RECHAZO_06",
      "RECHAZO_08",
      "RECHAZO_10",
      "RECHAZO_11",
      "RECHAZO_12",
      "RECHAZO_13",
      "RECHAZO_702",
      "RECHAZO_03",
      "RECHAZO_701",
      "SIN_PRESTAMOS_DISPONIBLES",
      "individuoNegativo",
      "datosIncorrectos",
      "RECHAZO_F_02",
      "RECHAZO_F_01",
      "mensaje-7"
    ];
    if (erroresRechazo.includes(errorCode)) {
      if (pixelMethod)
        window.gtag("event", "conversion", {
          send_to: pixelMethod
        });
    }
  }
};

export { GoogleSiteTag };
